import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import image2 from "../../Assets/image2.jpeg";
import image3 from "../../Assets/image3.png";

import Headers from "../../Components/Headers";
import Footer from "../../Components/Footers";

const image1 =
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot+2026-01-07+101628.png";

/* 🔹 Example PDF preview screenshots (replace with real S3 links) */
const pdfPreviewImages = [
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105151.png",
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105208.png",
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105219.png",
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105229.png",
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105240.png",
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105252.png",
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105302.png",
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105315.png",
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105326.png",
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105334.png",
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105346.png",
  "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot 2026-01-12 105354.png",
];

const workshops = [
  {
    id: 1,
    title: "The Rules To Break",
    date: "15th December 2025",
    img: image1,
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    priceLabel: "50 Euros",
    previewImages: pdfPreviewImages,
  },
  {
    id: 2,
    title: "Cosmos and Albumen",
    date: "15th December 2025",
    img: image2,
    description:
      "It has survived not only five centuries but also the leap into electronic typesetting.",
    priceLabel: "50 Euros",
    previewImages: pdfPreviewImages,
  },
  {
    id: 3,
    title: "Activating Charcoal",
    date: "15th December 2025",
    img: image3,
    description:
      "It was popularised in the 1960s with the release of Letraset sheets.",
    priceLabel: "50 Euros",
    previewImages: pdfPreviewImages,
  },
];

const Publications = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [paymentFailed, setPaymentFailed] = useState(false);
  const [loadingId, setLoadingId] = useState(null);

  /* 🔹 Intro popup state */
  const [showIntro, setShowIntro] = useState(false);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);

  /* 🔹 Slider state */
  const [currentSlide, setCurrentSlide] = useState(0);

  /* 🔔 Stripe failure detect */
  useEffect(() => {
    const status = searchParams.get("status");
    if (status === "failed") {
      setPaymentFailed(true);
      searchParams.delete("status");
      setSearchParams(searchParams, { replace: true });
    }
  }, []);

  const handleStripeClick = async (workshopId, e) => {
    e?.stopPropagation();
    setLoadingId(workshopId);

    try {
      const res = await fetch("/api/rent", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ workshopId }),
      });

      const data = await res.json();

      if (data.url) {
        window.location.href = data.url;
      } else {
        setPaymentFailed(true);
      }
    } catch (err) {
      console.error(err);
      setPaymentFailed(true);
    } finally {
      setLoadingId(null);
    }
  };

  /* 🔹 Slider helpers */
  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === selectedWorkshop.previewImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? selectedWorkshop.previewImages.length - 1 : prev - 1
    );
  };

  return (
    <>
      <Headers />

      <div className="workshops-page">
        <h1 className="page-title">Publications</h1>

        {/* ❌ Payment Failed */}
        {paymentFailed && (
          <div className="payment-error-overlay">
            <div className="payment-error-box">
              <button
                className="payment-error-close"
                onClick={() => setPaymentFailed(false)}
              >
                ✕
              </button>
              <h2>Payment Unsuccessful</h2>
              <p>Please try again or use a different payment method.</p>
            </div>
          </div>
        )}

        {/* ✅ INTRO POPUP WITH SLIDER */}
        {showIntro && selectedWorkshop && (
          <div className="intro-overlay">
            <div className="intro-box">
              <button
                className="intro-close"
                onClick={() => setShowIntro(false)}
              >
                ✕
              </button>

              {/* 🔹 PDF PREVIEW SLIDER */}
              <div className="preview-slider">
                <button className="slider-btn left" onClick={prevSlide}>
                  ‹
                </button>

                <img
                  src={selectedWorkshop.previewImages[currentSlide]}
                  alt="PDF Preview"
                  className="preview-image"
                />

                <button className="slider-btn right" onClick={nextSlide}>
                  ›
                </button>
              </div>

              {/* 🔹 Dots */}
              <div className="slider-dots">
                {selectedWorkshop.previewImages.map((_, index) => (
                  <span
                    key={index}
                    className={`dot ${
                      currentSlide === index ? "active" : ""
                    }`}
                    onClick={() => setCurrentSlide(index)}
                  />
                ))}
              </div>

              <h2>{selectedWorkshop.title}</h2>

              <p className="intro-text">
                From childhood, we inherit countless “rules” about life—ideas we
                accept without questioning.
                <br /><br />
                This publication challenges those inherited rules, encouraging
                independent thinking, self-trust, and conscious decisions.
                <br /><br />
                Learn when to follow the rules, when to bend them, and when to
                break them entirely.
              </p>

              <button
                className="continue-button"
                disabled={loadingId === selectedWorkshop.id}
                onClick={(e) => {
                  setShowIntro(false);
                  handleStripeClick(selectedWorkshop.id, e);
                }}
              >
                {loadingId === selectedWorkshop.id
                  ? "Redirecting..."
                  : `Continue to Buy for ${selectedWorkshop.priceLabel}`}
              </button>
            </div>
          </div>
        )}

        {/* 🔹 Workshop cards */}
        <div className="workshops-grid">
          {workshops.map((w) => (
            <div key={w.id} className="workshop-card">
              <img src={w.img} alt={w.title} className="workshop-image" />

              <div className="workshop-content">
                <h2 className="workshop-title">{w.title}</h2>
                <p className="workshop-desc">{w.description}</p>
              </div>

              <div className="workshop-footer">
                <button
                  className="price-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedWorkshop(w);
                    setCurrentSlide(0);
                    setShowIntro(true);
                  }}
                >
                  Rent Now For {w.priceLabel}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Publications;
